<ng-container *ngIf="!viewedAthlete?.rights?.view">
    <div class="alert alert-warning">
        <i class="material-icons">report_problem</i>
        {{ 'Not_Viewable_Athlete' | translate }}
    </div>
</ng-container>

<ng-container *ngIf="organization && viewedAthlete?.rights?.view">

    <section class="ath-side-box-avatar">
        <img class="background"
             [src]="conf.assetsUrl + 'img/courbe-profile-v2.svg'" />
        <div class="ath-side-avatar">
            <div class="ath-edition">
                <button *ngIf="viewedAthlete?.rights?.edit" mat-mini-fab
                        class="ath-small-button ath-edit-button"
                        [matTooltip]="'Edit' | translate"
                        color="none"
                        (click)="onModifyAthleteClicked(viewedAthlete!)">
                    <mat-icon color="primary">create</mat-icon>
                </button>
            </div>
            <div class="ath-edition">
                <button *ngIf="viewedAthlete?.rights?.chat" mat-mini-fab
                        class="ath-small-button ath-msg-button"
                        color="none"
                        [disabled]="discussionLoading"
                        [matTooltip]="'Message' | translate"
                        (click)="onMessageAthleteClicked(viewedAthlete!)">
                    <mat-icon color="primary">chat_bubble_outline</mat-icon>
                </button>
            </div>
            <div class="ath-avatar">
                <img *ngIf="viewedAthlete?.user?.avatar"
                     [src]="conf.storageRootUrl + viewedAthlete?.user?.avatar"  alt="athlete avatar"/>
                <mat-icon *ngIf="!viewedAthlete?.user?.avatar">
                    account_circle
                </mat-icon>
            </div>
        </div>
    </section>

    <section class="ath-side-menu">
        <div class="ath-side-box ath-side-buttons">
            <button mat-button
                [disabled]="false"
                (click)="onGotoStatisticsClicked(viewedAthlete!)"
                class="ath-button">
                <i class="material-icons">show_chart</i>{{ 'Athlete_Statistics' | translate }}
            </button>
            <button mat-button
                    [disabled]="false"
                    [routerLink]="'/' + organization.code + '/athletes/' + viewedAthlete?.athlete?.userId"
                    class="ath-button">
                <i class="material-icons">view_module</i>{{ 'Athlete_Dashboard' | translate }}
            </button>
        </div>

        <div class="ath-side-box ath-side-name">
            <app-feedback-athlete-smiley [athlete]="athlete" [organization]="organization"></app-feedback-athlete-smiley>
            <div class="ath-name">{{ viewedAthlete?.user?.firstName + ' ' + viewedAthlete?.user?.lastName }}</div>
        </div>

        <div class="ath-side-box ath-side-birthday">
            {{ viewedAthlete?.athlete?.birthday??''|appDate:'dd.MM.yy' }} | {{ viewedAthlete?.gender?.name }}
        </div>

        <div class="ath-side-box ath-side-weight-size">
            <div class="ath-weight">{{ viewedAthlete?.athlete?.weight }} {{ 'kg'|translate }}</div>
            <div class="ath-size">{{ viewedAthlete?.athlete?.size }} {{ 'cm'|translate }}</div>
        </div>

        <div class="ath-side-box ath-side-separator">
            <hr />
        </div>

        <div class="ath-side-box ath-side-practiced-sport">
               <table class="ath-sport">
                   <tr>
                       <td class="ath-td-first">{{ 'Athlete_Sport' | translate }}</td>
                       <td>{{ viewedAthlete?.athlete?.sportsPracticed | default:'-' }}</td>
                   </tr>
                   <tr>
                       <td class="ath-td-first">{{ 'Athlete_Contract_Type' | translate }}</td>
                       <td>{{ viewedAthlete?.contractType?.name | default:'-' }}</td>
                   </tr>
                   <tr>
                       <td class="ath-td-first">{{ 'Athlete_Club' | translate }}</td>
                       <td>{{ viewedAthlete?.athlete?.clubName | default:'-' }}</td>
                   </tr>
               </table>
        </div>

        <div class="ath-side-box ath-side-separator">
            <hr />
        </div>

        <div class="ath-side-box ath-side-teams">
               <table class="ath-teams">
                   <tr>
                       <td class="ath-td-first">{{ 'Athlete_Coach' | translate }}</td>
                       <td>{{ viewedAthlete?.coachNames | default:'-' }}</td>
                   </tr>
                   <tr>
                       <td class="ath-td-first">{{ 'Athlete_Trainer' | translate }}</td>
                       <td>{{ viewedAthlete?.athlete?.externalCoachName | default:'-' }}</td>
                   </tr>
                   <tr>
                       <td class="ath-td-first">{{ 'Athlete_Team' | translate }}</td>
                       <td>{{ viewedAthlete?.teamNames | default:'-' }}</td>
                   </tr>
               </table>
        </div>

        <div class="ath-side-box ath-side-separator">
            <hr />
        </div>

        <div class="ath-side-box ath-side-description">
            <div>{{ 'Objectives' | translate }}</div>
            <p>{{ activeAnnualPlan?.comment  | default:'-'}}</p>
        </div>

        <div class="ath-side-box ath-side-contact">
            <button mat-button
                [disabled]="false"
                (click)="onContactInfoAthleteClicked(viewedAthlete!)"
                class="ath-button">
                <i class="material-icons">call</i>{{ 'Athlete_Contact' | translate }}
            </button>
        </div>

</section>

</ng-container>
